import styled, { css } from 'styled-components';

import VdpBox from '../../../_shared/components/VdpBox';
import Box from '../../../_shared/components/Box';
import Icon from '../../../_shared/components/Icon';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';

import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

/**
 * Variant Definitions
 */
const StyledResearchHeadingVariants = {
  mini: css`
    margin: 0 0 11px 0;
  `,
  expanded: css`
    margin: 0 7px 0 0;
  `
};

const StyledHeadingBoxVariants = {
  mini: {
    main: css`
      flex-direction: column;
    `,
    p: css`
      margin: 0 0 24px 0;
    `
  },
  expanded: {
    main: css`
      flex-direction: column;
    `,
    p: css`
      margin: 0;
    `
  }
};

const StyledResearchPricesBoxVariants = {
  mini: css`
    width: 100%;
    margin-top: 10px;
  `,
  expanded: css`
    width: 50%;
    margin-top: 36px;
  `
};

/**
 * Styled Components
 */
export const StyledResearch = styled(VdpBox)`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledResearchHeading = styled.h2`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledResearchHeadingVariants.mini,
      expanded: StyledResearchHeadingVariants.expanded
    })}
`;

export const StyledHeadingBox = styled(Box)`
  width: 100%;
  justify-content: space-between;
  height: max-content;
  margin-bottom: 10px;

  p {
    ${({ theme }) =>
      applyResponsiveVdpStyles(theme, {
        mini: StyledHeadingBoxVariants.mini.p,
        expanded: StyledHeadingBoxVariants.expanded.p
      })}
  }

  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledHeadingBoxVariants.mini.main,
      expanded: StyledHeadingBoxVariants.expanded.main
    })}
`;

export const StyledResearchBox = styled(Box)`
  width: 100%;
  height: max-content;
  flex-direction: column;
`;

export const StyledHeadingBoxSub = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 12px;
  p {
    line-height: ${({ theme }) => theme.FONT_SIZES.BASE};
  }
`;

export const StyledResearchPricesBox = styled(Box)`
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledResearchPricesBoxVariants.mini,
      expanded: StyledResearchPricesBoxVariants.expanded
    })}

  ul {
    width: 100%;

    li {
      padding: 13px 0;
      border-bottom: 1px solid
        ${({ theme }) =>
          isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_10};
      display: flex;
      justify-content: space-between;

      &:last-child {
        border: none;
      }

      p {
        margin: 0;

        &:first-child {
          font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
        }

        &:last-child {
          color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
        }
      }
    }
  }
`;

export const StyledIcon = styled(Icon)`
  width: 17px;
  height: 17px;
  margin-left: 12px;
`;

export const StyledResearchHeadingLink = styled.a`
  align-self: center;
`;

export const NoMarketGuideDataBanner = styled.div`
  display: inline-flex;
  gap: 12px;
  border: 1px solid transparent;
  border-left: 9px solid transparent;
  border-radius: 3px;
  border-color: ${({ theme }) => theme.COLORS.INFO_BLUE};
  padding: 12px;
  width: 100%;
`;

export const NoMarketGuideDataBoldLabel = styled.span`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;
